import { DesktopLandingGifItem } from '@modules/Landing/Shared/Interfaces/DesktopLandingGifItem';
import css from './CategoryItem.module.css';
import classNames from 'classnames';

interface CategoryItemProps {
    item: DesktopLandingGifItem;
    itemIndex: number;
    isActive: boolean;
    onClick: () => void;
}

export const CategoryItem: React.FC<CategoryItemProps> = ({
    item,
    itemIndex,
    onClick,
    isActive,
}) => {
    return (
        <div
            className={classNames(css.item, isActive && css.active)}
            onClick={onClick}
        >
            <div>{item.icon}</div>
            <div className={css.nameWithIndex}>
                <div className={css.index}>{itemIndex}:</div>
                <div>{item.name}</div>
            </div>
        </div>
    );
};
